<template>
  <div class="body_left">
    <div class="left_top no_mobile">
      <img src="@/images/topic_thum_74.png" alt="" />
      <span>{{ menuTitle }}</span>
    </div>
    <div class="left_body">
      <ul class="menu">
        <li v-if="leftMenus && leftMenus.length > 0">
          <router-link
            v-for="menu in leftMenus"
            :key="menu.leftMenuId"
            :to="getRoute(menu)"
            :class="{ on: isActive(menu) }"
            @click="goToMenu(menu)"
          >
            {{ menu.menuName }}
          </router-link>
        </li>
        <li v-else>
          <router-link
            :to="getRoute(emptyMenuRoute)"
            class="on"
            @click="goToMenu(emptyMenuRoute)"
          >
            {{ emptyMenuName }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import apiClient from "@/apiClient"; // 설정 파일에서 가져온 axios 인스턴스

export default {
  data() {
    return {
      emptyMenuName: "",
    };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    menuTitle() {
      return this.$store.state.selectedMenu;
    },
    userId() {
      return this.$store.getters.getUserid;
    },
    userName() {
      return this.$store.getters.getUsername;
    },
    userType() {
      return this.$store.getters.getUsertype;
    },
    userPermission() {
      return this.$store.getters.getUserpermission;
    },
    companyid() {
      return this.$store.getters.getCompanyid;
    },
    leftMenus() {
      return this.$store.getters.getFilteredLeftMenus;
    },
    emptyMenuRoute() {
      return this.$store.state.menuMode === "M"
        ? "/mizenotices/list"
        : "/notices/list";
    },
  },
  methods: {
    async getLeftMenu() {
      if (this.$store.state.leftMenus.length > 0) return;

      try {
        const user = {
          LoginUserId: localStorage.getItem("userid"),
          UserType: localStorage.getItem("usertype"),
          TopMenuId: this.$store.state.selectedMenuId,
          MenuMode: this.$store.state.menuMode,
        };

        const response = await apiClient.post("/api/Menu/left-menu-list", user);

        if (response.status === 200) {
          this.$store.commit("setLeftMenus", JSON.parse(response.data).data);
        }
      } catch (error) {
        console.error("Error fetching left menu data:", error);
      }
    },
    getRoute(menu) {
      if (typeof menu === "string") {
        return menu;
      }
      if (menu.menuLink) {
        return "/" + menu.menuLink.replace(/^\/+/, "");
      }
      return "/";
    },
    goToMenu(menu) {
      if (menu.menuLink === "") {
        alert("준비중입니다.");
        let menuMode = this.userType === "M" ? "M" : "C";
        this.$store.commit("setSelectedMenu", "공지사항");
        this.$store.commit(
          "setSelectedMenuId",
          this.findTopMenuId(this.$store.state.topMenus, menuMode, "공지사항")
        );
        this.$store.commit("setLeftMenus", []);
        this.setEmptyMenu(
          "공지사항목록",
          this.$store.state.menuMode === "M"
            ? "/mizenotices/list"
            : "/notices/list"
        );

        if (this.userType === "M") {
          this.$router.replace({ path: "/temp-route" }).then(() => {
            this.$router.push({ path: "/mizenotices/list" });
          });
        } else {
          this.$router.replace({ path: "/temp-route" }).then(() => {
            this.$router.push({ path: "/notices/list" });
          });
        }
        return;
      }

      if (menu.menuLink === this.$route.path || typeof menu === "string") {
        const currentPath = this.$route.path;
        this.$store.commit("setRefreshFlag", true);

        this.$router.replace({ path: "/temp-route" }).then(() => {
          this.$router.replace(currentPath);
        });
      } else {
        this.$store.commit("setRefreshFlag", false);
        return this.$route.path;
      }
    },
    findTopMenuId(menuData, menuMode, menuName) {
      const matchedMenu = menuData.find((menu) => {
        return menu.menuName === menuName && menu.menuMode === menuMode;
      });

      if (matchedMenu) {
        return matchedMenu.topMenuId;
      }
    },
    isActive(menu) {
      const routePath = this.getRoute(menu);
      const currentPath = this.$route.path;

      if (currentPath === routePath) return true;

      if (menu.relatedMenuPath) {
        const relatedMenuPaths = menu.relatedMenuPath
          .split(",")
          .map((menuPath) => menuPath.trim());
        return relatedMenuPaths.some((menuPath) =>
          currentPath.startsWith(menuPath)
        );
      }

      return false;
    },
    setEmptyMenu(name, route) {
      this.emptyMenuName = name;
      this.emptyMenuRoute = route;
    },
  },
  beforeUnmount() {},
  mounted() {
    console.log("Left Menus:", this.leftMenus);
  },
};
</script>

<style scoped></style>
